import { useState } from 'react';
import { ReactComponent as TooltipIcon } from '../../../../assets/icons/Tooltip.svg';
import Styles from './index.module.scss';
import i18n from '../../../../utils/translations/i18n';

const Tooltip = ({ id = 'tooltip', content, delay = 100, direction = 'right', className = '', onHover }) => {
    const { t } = i18n;
    let timeOut;
    const [active, setActive] = useState(false);

    const show = () => {
        onHover();
        timeOut = setTimeout(() => {
            setActive(true);
        }, delay);
    }

    const hide = () => {
        clearInterval(timeOut);
        setActive(false);
    }

    return (
        <div id={id} className={`${Styles.container} ${Styles[direction]} ${className}`} onMouseEnter={show} onMouseLeave={hide} role="button" tabIndex={0}>
            <span className={`${active && Styles.tooltipIcon}`} aria-label={t('sign-in.tooltip_icon_aria_label')}> 
                <TooltipIcon /> 
            </span>
            {active && <div className={`${Styles.tooltip} ${Styles[direction]}`}>{content}</div>}
        </div>
    )
}

export default Tooltip;
